/* ============
 * Campaign Transformer
 * ============
 */

import Transformer from './transformer';

export default class CampaignTransformer extends Transformer {

  static fetch(campaign) {
    return {
      id: campaign.id,
      name: campaign.name,
      description: campaign.description,
      campaignTypeId: campaign.campaign_type_id,
      campaignType: campaign.campaign_type,
      newsSubscriberListId: campaign.news_subscriber_list_id,
      newsSubscriberList: campaign.news_subscriber_list,
      createdAt: campaign.created_at,
    };
  }

  static send(campaign) {
    return {
      name: campaign.name,
      description: campaign.description,
      campaign_type_id: campaign.campaignTypeId,
      news_subscriber_list_id: campaign.newsSubscriberListId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/campaign.js